import React from 'react'

import { Select } from '@grandvisionhq/forms'

export const CountryFixed = () => {
  const countryOptions = {
    'United Kingdom': 'GB',
  }
  return (
    <Select
      id="country"
      name="country"
      options={countryOptions}
      label="Country"
      disabled={true}
      initialState={{
        value: 'GB',
      }}
    />
  )
}
